import { Box, CardContent, Skeleton, Stack, Typography } from "@mui/material";
import type React from "react";

const SingleTranslatorSkeleton: React.FC = () => {
	return (
		<CardContent
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: 360,
				flexGrow: 1,
			}}
		>
			{/* Rating placeholder */}
			<Box sx={{ mb: 1 }}>
				<Skeleton variant="text" width={80} height={20} />
			</Box>

			{/* Name and email form placeholder */}
			<Stack spacing={1.2} sx={{ mb: 2 }}>
				<Skeleton variant="text" width={180} height={28} />
				<Skeleton
					variant="rectangular"
					height={32}
					sx={{ width: 260, maxWidth: "100%" }}
				/>
			</Stack>

			{/* Suspended/Activated since line */}
			<Skeleton variant="text" width={220} height={18} />

			{/* Totals section placeholders */}
			<Stack spacing={1.2} sx={{ mt: 2 }}>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Skeleton variant="text" width={120} height={20} />
					<Skeleton variant="text" width={90} height={20} />
				</Box>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Skeleton variant="text" width={140} height={20} />
					<Skeleton variant="text" width={70} height={20} />
				</Box>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Skeleton variant="text" width={160} height={20} />
					<Skeleton variant="text" width={80} height={20} />
				</Box>
			</Stack>

			{/* Active clients list preview */}
			<Typography variant="caption" sx={{ mt: 2, mb: 0.5 }}>
				<Skeleton variant="text" width={160} height={16} />
			</Typography>
			<Stack spacing={1}>
				{[0, 1, 2].map((i) => (
					<Box
						key={i}
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Skeleton variant="text" width={160} height={20} />
						<Skeleton variant="text" width={60} height={20} />
					</Box>
				))}
			</Stack>

			{/* Bottom actions placeholder */}
			<Box sx={{ mt: "auto", pt: 2 }}>
				<Skeleton
					variant="rectangular"
					height={48}
					sx={{ width: "100%", borderRadius: 1 }}
				/>
			</Box>
		</CardContent>
	);
};

export default SingleTranslatorSkeleton;
